export type TagDetectionClassification =
  | "finish_tag"
  | "room_tag"
  | "door_window_tag"
  | "reference_noise"
  | "unknown";

export type DocumentTagPlacementMode = "add" | "duplicate" | null;

export interface DocumentTagOption {
  id: string;
  label: string;
  rawText: string;
  normalizedText?: string;
  classification?: TagDetectionClassification;
  bbox?: { x: number; y: number; width: number; height: number };
  color?: string;
}

export function getDetectionMatchText(detection: { rawText: string; normalizedText?: string }) {
  return detection.normalizedText ?? detection.rawText;
}

export function normalizeTagMatchText(value: string) {
  return value.trim().toLowerCase().replace(/[^a-z0-9]+/g, "");
}

export function getOptionMatchText(option: DocumentTagOption) {
  return normalizeTagMatchText(option.normalizedText ?? option.rawText);
}
